import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpRequestService } from 'src/app/_services/http-request.service';
import { CorporateActions } from 'src/app/_models/corporate-actions';
import { TranslateService } from '@ngx-translate/core';
import { tap } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-corporate-actions',
  templateUrl: './corporate-actions.component.html',
  styleUrls: ['./corporate-actions.component.css']
})
export class CorporateActionsComponent implements OnInit {

  corporateActionsData: CorporateActions[] = [];

  constructor(private httpRequestService: HttpRequestService, private translate: TranslateService) { }

  ngOnInit() {
    this.getCorporateActions();
  }

  getCorporateActions() {
    return this.httpRequestService.corporateActionsData.pipe(tap(responseData => {
      this.corporateActionsData = [];
      if (responseData.length === 0)
        return;
      this.corporateActionsData = responseData;
    })).toPromise();
  }
}
